import { Component, OnInit, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  isLoading = false;
  loginErrors = null;
  data = null;
  mode = 'login';
  clicked = false;
  SignLoading = false;
  password;
  selected = 'Patient';
  role = localStorage.getItem('role');
  show = false;

  forgot() {
    this.mode = 'pass';
  }
  switch() {
    this.show = !this.show;
  }

  login() {
    this.mode = 'login';
  }

  loginForm = new FormGroup({
    email: new FormControl(''),
  });

  constructor(
    public auth: AuthServiceService,
    public router: Router,
    private zone: NgZone,
    private _snackBar: MatSnackBar
  ) {}

  logins() {
    this.mode = 'login';
  }
  signup() {
    this.router.navigateByUrl('/');
  }

  submit() {
    this.SignLoading = true;
    console.log(this.loginForm.value);
    const { email } = this.loginForm.value;
    this.auth.resetPassword(email).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess;
        this.SignLoading = false;

        console.log('user object', this.data);
        if (resSuccess.isSuccessful) {
          this._snackBar.open('Successfull: check email for reset link', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          // this.router.navigateByUrl('/profile');
          this.loginForm.reset();
        } else {
          this._snackBar.open('Error please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.isLoading = false;
        }
      },
      (resErr) => {
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        this.SignLoading = false;
      }
    );
  }

  ngOnInit(): void {}
}
